import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { CardSection } from "@/components/Section";
import { IContactPerson } from "@/data/consultant-profiles";
import { TStyleBoolOrSize } from "@/eworkitComponents";

import { ContactPerson } from "./ContactPerson";

interface IContactSectionProps {
  contactPerson: IContactPerson;
  originName?: string;
  hasIcon?: boolean;
  innerMargin?: TStyleBoolOrSize;
}

export const ContactSection: FC<IContactSectionProps> = ({
  contactPerson,
  originName,
  hasIcon,
  innerMargin = "md",
}) => {
  const { t } = useTranslation("session");

  return (
    <CardSection padding={["lg"]} direction="column" innerMargin={innerMargin}>
      <Header color="black" size="sm" weight="bold">
        {t("COMPONENTS.CONTACT_SECTION.HEADER", { name: originName })}
      </Header>

      <ContactPerson contactPerson={contactPerson} hasIcon={hasIcon} />
    </CardSection>
  );
};
